import api from '@/utils/axios';

const userService = {
  async signIn(credentials) {
    try {
      const data = await api.post('/api/v1/login', credentials);
      return {
        token: data.token,
        username: data.username,
        role: data.role,
      };
    } catch (error) {
      console.error('로그인에 실패했습니다. 다시 시도해주세요.', error);
    }
  },
  async getUserList() {
    const data = await api.get('/api/v1/users');
    return Array.isArray(data)
      ? data.map(userInfo => {
          return {
            id: userInfo.id,
            name: userInfo.name,
            role: userInfo.role,
            type: userInfo.type,
            status: userInfo.status,
            description: userInfo.description,
            lastLoginDateTime: userInfo.lastLoginDateTime,
          };
        })
      : [];
  },
  async registUser(userInfo) {
    try {
      const data = await api.post('/api/v1/users', userInfo);
      return data;
    } catch (error) {
      throw (
        error.response?.data?.message || '사용자 등록 중 오류가 발생했습니다.'
      );
    }
  },

  async updateUser(userId, updateData) {
    try {
      if (!userId) throw new Error('User ID is required');

      await api.patch(`/api/v1/users/${userId}`, {
        description: updateData.description,
        type: updateData.type,
        status: updateData.status,
      });
    } catch (error) {
      console.error('Failed to update user:', error);
      throw error;
    }
  },

  async resetPassword(userId, newPassword) {
    try {
      if (!userId) throw new Error('User ID is required');

      await api.patch(`/api/v1/users/${userId}/password`, {
        password: newPassword,
      });
    } catch (error) {
      console.error('Failed to reset password:', error);
      throw error;
    }
  },

  async getUserLogs(date) {
    try {
      const response = await api.get('/api/v1/users/logs', {
        date: date,
      });
      return Array.isArray(response)
        ? response.map(log => ({
            id: log.id,
            userId: log.userId,
            username: log.username,
            eventType: log.eventType,
            createdAt: log.createdAt,
            metadata:
              typeof log.metadata === 'string'
                ? JSON.parse(log.metadata)
                : log.metadata,
          }))
        : [];
    } catch (error) {
      console.error('Error fetching user logs:', error);
      throw error;
    }
  },

  async checkAuth() {
    try {
      const response = await api.get('/api/v1/users/auth/check');
      return response || false;
    } catch (error) {
      if (error.response && [401, 403].includes(error.response.status)) {
        return false;
      }
      console.error('checkAuth error', error);
      return false;
    }
  },

  async sendHealthCheck(pageUrl = null) {
    try {
      const headers = {};
      if (pageUrl) {
        headers['X-Page-Url'] = pageUrl;
      }
      await api.post('/api/v1/users/health', {}, { headers });
    } catch (error) {
      console.error('Health check 전송 실패:', error);
    }
  },

  async getActiveUserList() {
    try {
      const response = await api.get('/api/v1/users/health');
      // 새로운 API 응답 구조에 맞게 수정
      return Array.isArray(response) ? response : [];
    } catch (error) {
      console.error('Health check 조회 실패:', error);
      return [];
    }
  },
};
export default userService;
